import React from "react";

const NonBreakableSpace = () => <>&nbsp;</>;

export default NonBreakableSpace;
